<template>
  <b-modal id="prompt-modal" centered hide-header hide-footer content-class="prompt-modal-content">
    <div class="prompt-modal-wrapper">
      <div class="prompt-modal-title">{{ parameters.title }}</div>
      <div class="prompt-modal-message">{{ parameters.message }}</div>
      <b-button
        class="prompt-modal-btn mt-4"
        block
        pill
        :style="buttonStyle"
        @click="handleButtonClick"
      >
        {{ parameters.buttonText || 'Close' }}
      </b-button>
    </div>
  </b-modal>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "PromptModal",
  props: {
    parameters: {
      type: Object,
      required: true
    }
  },
  computed: {
    ...mapState("estore", ["webDesign"]),
    buttonStyle() {
      if (
        this.webDesign &&
        this.webDesign.design &&
        this.webDesign.design.main_color &&
        this.webDesign.design.button_text_color
      ) {
        return {
          background: this.webDesign.design.main_color + ' !important',
          color: this.webDesign.design.button_text_color + ' !important',
          border: 'none !important',
        };
      }
      return {};
    },
  },
  methods: {
    handleButtonClick() {
      if (typeof this.parameters.buttonFunction === 'function') {
        this.parameters.buttonFunction();
      }
      this.$root.$emit('bv::hide::modal', 'prompt-modal');
    }
  }
};
</script>

<style lang="scss">
#prompt-modal {
  .prompt-modal-content {
    border-radius: 20px;
    padding: 0;
    max-width: 492px;
    width: 100%;
    box-shadow: 0 2px 16px rgba(0,0,0,0.08);
    background: #fff;
    text-align: center;
  }
}
.prompt-modal-wrapper {
  padding: 15px 54px;
}
.prompt-modal-title {
  font-size: 24px;
  font-family: 'SKModernistBold', sans-serif;
  margin-bottom: 16px;
  color: #2F3941;
}
.prompt-modal-message {
  font-size: 1.1rem;
  color: #232323;
  margin-bottom: 32px;
}
.prompt-modal-btn {
  background: #ff6600 !important;
  color: #fff !important;
  border: none !important;
  border-radius: 28px !important;
  padding: 16px 0 !important;
  width: 80%;
  font-size: 16px;
  font-family: 'SKModernistBold', sans-serif;
  cursor: pointer;
  transition: background 0.2s;
  margin: 0 auto;
  display: block;
}
</style>